export function buildStickerFairyPrompt(input: string): string {
  const trimmed = input.trim();
  if (!trimmed) {
    return 'Always fill unused space with solid white background.';
  }

  // Gemini image generation has been flaky when prompts include punctuation
  // sequences like `!.` or `..` (it returns no image). Normalize those cases.
  const normalized = trimmed
    .replace(/([!?])\.+/g, '$1')
    .replace(/\.{2,}/g, '.')
    .replace(/\s{2,}/g, ' ');

  const needsSeparator = /[.!?]$/.test(normalized) ? ' ' : '. ';
  return `${normalized}${needsSeparator}Always fill unused space with solid white background.`;
}

